import React from 'react';

export const Unauthorized: React.FC = () => {
  return <h3 className="font-med">
    You don't have permission to view this option.
  </h3>
}